import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import 'slick-carousel';
import getGalleryConfig from "../config/gallery-config";
import GalleryView from "../views/gallery-view";

@Options({
    template: false,
    ui: {}
})

export default class BlogScroller extends Marionette.View<Backbone.Model>{
    config?: object;
    cta?: any;
    lastWidth?: number;
    readonly breakpoint: number = 768;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};

        this.slickify();

        this.lastWidth = window.innerWidth;
    }

    onRender() {
        window.addEventListener('resize', () => {
            if (window.innerWidth >= this.breakpoint && this.lastWidth < this.breakpoint) {
                // build new slider
                this.slickify();

                this.lastWidth = window.innerWidth;
            } else if (window.innerWidth < this.breakpoint && this.lastWidth >= this.breakpoint) {
                try {
                    // deslick
                    this.$el.slick('unslick');
                } catch (e) {
                    console.warn('unslick failed!');
                    // if you saw this error and came here, don't worry.
                    // this is usually not an error - we call unslick when
                    // the if statement is true EVEN IF the element has not
                    // been slickified.
                }

                this.lastWidth = window.innerWidth;
            }

            // otherwise, you're just resizing within breakpoint bounds
            // so we won't rebuild the slider to save performance points
        })
    }

    slickify() {
        let isRelatedPostsSection = document.body.classList.contains('event-detail-page')
            || document.body.classList.contains('artist-page')
            || document.body.classList.contains('piece-page');

        if (isRelatedPostsSection && +this.$el.attr('data-blog-post-count') <= 3) {
            console.log(document.body.classList.contains('event-detail-page'));
            console.log(+this.$el.attr('data-blog-post-count') <= 3);
            this.$el.addClass('blog-scroller--no-slick');
        } else {
            let config = getGalleryConfig("blog-scroller");
            if(window.innerWidth >= this.breakpoint) {
                try {
                    this.$el.slick(config);
                } catch (e) {
                    console.warn('slickify failed!');
                }
            }
        }
    }
}




// WEBPACK FOOTER //
// ./@modules/views/blog-scroller.ts